import store from '@core/store';

/**
 * Add a dialog item to the queue
 * @param {Object} options
 */
export const dialog = options => {
    store.dispatch(`dialogQueue/add`, options);
};

/**
 * Clear all dialog items in the queue
 * @param {Object} options
 */
export const clearDialogs = () => {
    store.dispatch(`dialogQueue/clear`);
};

/**
 * Add a snack item to the queue
 * @param {Object} options
 */
export const snack = options => {
    store.dispatch(`snackQueue/add`, options);
};

/**
 * Clear all snack items in the queue
 * @param {Object} options
 */
export const clearSnacks = () => {
    store.dispatch(`snackQueue/clear`);
};

/**
 * Set the breadcrumbs
 * @param {Array} crumbs
 */
export const setBreadcrumbs = crumbs => {
    store.dispatch(`app/setBreadcrumbs`, crumbs);
};

/**
 * Hide the breadcrumbs
 */
export const hideBreadcrumbs = () => {
    store.dispatch(`preferences/setShowBreadcrumbs`, false);
};

/**
 * Show the breadcrumbs
 */
export const showBreadcrumbs = () => {
    store.dispatch(`preferences/setShowBreadcrumbs`, true);
};
